// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as LastCard$Showside from "./LastCard.bs.js";
import * as ProductCard$Showside from "./ProductCard.bs.js";
import * as ListPageGrid$Showside from "./ListPageGrid.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ListPageSlider$Showside from "./ListPageSlider.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as PlaceholderCard$Showside from "./PlaceholderCard.bs.js";
import * as ProductsContent$Showside from "./ProductsContent.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as CartContextProvider$Showside from "../context/CartContextProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as GridDensityZoomProvider$Showside from "../context/GridDensityZoomProvider.bs.js";
import * as UserSavedProductsProvider$Showside from "../context/UserSavedProductsProvider.bs.js";
function useLocalStorageProductIds(requestType) {
  var hook = UserSavedProductsProvider$Showside.use(undefined);
  var entries = requestType === "history" ? hook.history.value : requestType === "favorites" ? hook.favorites.value : [];
  var ids = Belt_Array.keepMap(entries, function (item) {
    if (item.TAG === /* Product */0) {
      return item._0.id;
    } else {
      return item._0;
    }
  });
  return [ids, Belt_Array.makeBy(ids.length, function (i) {})];
}
function useUserSavedProducts(hideOutOfStockOpt, shouldFetchOpt, fixedOrderOpt, categoryId, requestType) {
  var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : false;
  var shouldFetch = shouldFetchOpt !== undefined ? shouldFetchOpt : true;
  var fixedOrder = fixedOrderOpt !== undefined ? fixedOrderOpt : false;
  var match = EntrypointContext$Showside.use(undefined);
  var match$1 = useLocalStorageProductIds(requestType);
  var match$2 = CartContextProvider$Showside.useCartProductIds(undefined);
  var match$3 = ConfigurationProvider$Showside.use(undefined);
  var match$4 = requestType === "favorites" || requestType === "history" ? [match$1[0], match$1[1]] : [match$2[0], match$2[1]];
  var productIds = match$4[0];
  var ids = Belt_Array.zip(productIds, match$4[1]);
  var match$5 = React.useState(function () {
    return ids;
  });
  var ids$1 = fixedOrder ? match$5[0] : ids;
  var hideOutOfStock$1 = requestType === "favorites" ? false : hideOutOfStock;
  var match$6 = UseApi$Showside.useProductsById(match$3.config.transitiveStoreId, productIds, hideOutOfStock$1, shouldFetch, Belt_Option.getWithDefault(categoryId, requestType), match.smartnavApiHost, match.market, undefined);
  var isFetching = match$6.isFetching;
  var match$7 = ProductsContent$Showside.usePersistentProducts(match$6.products, isFetching, false);
  var isFetching$1 = ids$1.length !== 0 && isFetching;
  var products = ids$1.length !== 0 ? match$7[0] : [];
  return {
    products: products,
    isFetching: isFetching$1,
    idDict: Js_dict.fromArray(ids$1)
  };
}
function UserSavedProductsContent(Props) {
  var layout = Props.layout;
  var category = Props.category;
  var shouldCenterSlidesOpt = Props.shouldCenterSlides;
  var isPaddingEnabledOpt = Props.isPaddingEnabled;
  var fixedOrderOpt = Props.fixedOrder;
  var zoomableOpt = Props.zoomable;
  var requestType = Props.requestType;
  var shouldCenterSlides = shouldCenterSlidesOpt !== undefined ? shouldCenterSlidesOpt : false;
  var isPaddingEnabled = isPaddingEnabledOpt !== undefined ? isPaddingEnabledOpt : true;
  var fixedOrder = fixedOrderOpt !== undefined ? fixedOrderOpt : false;
  var zoomable = zoomableOpt !== undefined ? zoomableOpt : true;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onOpenLink = match$1.onOpenLink;
  var onProductClick = match$1.onProductClick;
  var onAddToCart = match$1.onAddToCart;
  var match$2 = RouterProvider$Showside.useRouter(undefined);
  var match$3 = ConfigurationProvider$Showside.use(undefined);
  var settings = match$3.config.settings;
  var match$4 = GridDensityZoomProvider$Showside.use(undefined);
  var match$5 = CartContextProvider$Showside.useCart(undefined);
  var isSmallestPossibleGrid = match$4.isSmallestPossibleGrid && zoomable;
  var removeAllInfo;
  var tmp = match$2.route;
  if (typeof tmp === "number") {
    removeAllInfo = false;
  } else {
    switch (tmp.TAG | 0) {
      case /* Home */0:
      case /* ListPage */1:
        removeAllInfo = isSmallestPossibleGrid;
        break;
      default:
        removeAllInfo = false;
    }
  }
  var checkoutLink = settings.cart ? match$5.storeCheckoutLink : settings.checkoutLink;
  var match$6 = useUserSavedProducts(settings.hideOutOfStock, undefined, fixedOrder, Belt_Option.map(category, function (category) {
    return category.id;
  }), requestType);
  var idDict = match$6.idDict;
  var isFetching = match$6.isFetching;
  var products = match$6.products;
  var placeholderText = requestType === "history" ? "There are no recently viewed items yet." : requestType === "favorites" ? "There are no items on your Favorites. Click the heart to add items." : "There are no items in your cart.";
  var placeholderCards = React.useMemo(function () {
    return Belt_Array.map(Js_dict.entries(idDict), function (param) {
      return React.createElement(PlaceholderCard$Showside.make, {
        shape: settings.productCardShape,
        kind: /* Product */0,
        contentBoxStylableClassName: "product-card__content-box",
        titleStylableClassName: "category-card__title",
        key: param[0] + Belt_Option.getWithDefault(param[1], "")
      });
    });
  }, [requestType, idDict]);
  var enableAddToCart = requestType !== "cart";
  var lastChild = requestType === "cart" && checkoutLink !== undefined ? Caml_option.some(React.createElement(LastCard$Showside.make, {
    href: checkoutLink,
    title: "Checkout Now",
    linkLabel: "",
    shape: settings.productCardShape
  })) : undefined;
  var keys = Belt_Array.map(Belt_Option.getWithDefault(products, []), function (product) {
    return Product$Showside.getKey(undefined, product);
  });
  var productCards = React.useMemo(function () {
    return Belt_Option.map(products, function (__x) {
      return Belt_Array.mapWithIndex(__x, function (dataCount, product) {
        var activeVariantId = Belt_Option.flatMap(Js_dict.get(idDict, product.id), function (a) {
          return a;
        });
        var key = Product$Showside.getKey(undefined, product) + Belt_Option.getWithDefault(activeVariantId, "");
        var tmp = {
          shape: settings.productCardShape,
          product: product,
          enableAddToCart: enableAddToCart,
          highlightActiveVariant: false,
          onClick: onProductClick,
          onAddToCart: onAddToCart,
          removeAllInfo: removeAllInfo,
          onOpenLink: onOpenLink,
          dataCount: dataCount,
          key: key
        };
        if (category !== undefined) {
          tmp.productCategory = Caml_option.valFromOption(category);
        }
        if (activeVariantId !== undefined) {
          tmp.activeVariantId = activeVariantId;
        }
        return React.createElement(ProductCard$Showside.make, tmp);
      });
    });
  }, [requestType, keys, isFetching]);
  var renderInLayout = React.useMemo(function () {
    return function (param) {
      if (layout.TAG === /* SliderLayout */0) {
        var match = layout._0;
        var tmp = {
          id: requestType,
          rows: match.rows,
          children: param,
          shouldCenter: shouldCenterSlides,
          slidesPerView: match.slidesPerView,
          gap: match.gap
        };
        if (match.padding !== undefined) {
          tmp.padding = match.padding;
        }
        if (match.maxWidth !== undefined) {
          tmp.maxWidth = match.maxWidth;
        }
        if (lastChild !== undefined) {
          tmp.lastSlide = Caml_option.valFromOption(lastChild);
        }
        return React.createElement(ListPageSlider$Showside.make, tmp);
      }
      var match$1 = layout._0;
      var tmp$1 = {
        columns: match$1.columns,
        children: param,
        gap: match$1.gap,
        alwaysShowLastChild: true
      };
      if (match$1.maxRows !== undefined) {
        tmp$1.maxRows = match$1.maxRows;
      }
      if (match$1.maxWidth !== undefined) {
        tmp$1.maxWidth = match$1.maxWidth;
      }
      var tmp$2 = isPaddingEnabled ? match$1.padding : 0;
      if (tmp$2 !== undefined) {
        tmp$1.paddingOverride = tmp$2;
      }
      if (lastChild !== undefined) {
        tmp$1.lastChild = Caml_option.valFromOption(lastChild);
      }
      return React.createElement(ListPageGrid$Showside.make, tmp$1);
    };
  }, [requestType, isMobile, layout]);
  var renderInTextBlock = function (string) {
    var tmp = {
      children: React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["text-lg text-primary", isMobile ? "px-4" : "px-8", shouldCenterSlides ? "text-center" : "text-left"]))
      }, string)
    };
    var tmp$1 = requestType === "history" ? "recently-viewed-placeholder" : requestType === "favorites" ? "favorites-placeholder" : undefined;
    if (tmp$1 !== undefined) {
      tmp.dataTestId = Caml_option.valFromOption(tmp$1);
    }
    return React.createElement(DataAttribute$Showside.make, tmp);
  };
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["w-full", isFetching ? "opacity-50 pointer-events-none" : ""]))
  }, productCards !== undefined ? productCards.length !== 0 ? Curry._1(renderInLayout, productCards) : renderInTextBlock(placeholderText) : isFetching ? Curry._1(renderInLayout, placeholderCards) : renderInTextBlock(placeholderText));
}
UserSavedProductsContent.displayName = "UserSavedProductsContent";
var make = React.memo(UserSavedProductsContent);
export { useLocalStorageProductIds, useUserSavedProducts, make };
/* make Not a pure module */